<template lang="pug">
  section
    header
      blau-title(:row="{title: 'Blue<br>Projects'}", :index="0")
      //- subnav
      nav.md--mt-20.px-30.flex.items-center.justify-center.trans-opacity-quick(:class="{'opacity-0': loading}")
        btn.flex-1.flex-grow.sm-flex-none.sm-min-w-btn.capitalize.-mr-px(v-for="(view, i) in views", v-show="hasRows(view)", :active="active === view", @click="changeView(view)", :key="i") {{view}}
    section.mt-120.relative
      //- TODO - future > present animation sucks... (because margin or padding in flexbody?)
      transition-group(name="pagefade")
        div(v-for="(view, i) in views", v-if="hasRows(view) && active === view", :key="view")
          //- present, future
          template(v-if="view !== 'past'")
            flex-body(:rows="rows(view)")
          //- past
          template(v-else)
            grid-scattered(:items="pastGridItems", v-if="!loading")
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import BlauTitle from '@/components/FlexBody/BlauTitle'
import FlexBody from '@/components/FlexBody/FlexBody'
import Btn from '@/components/Btn'
import RespImg from '@/components/RespImg'
import get from 'lodash/get'
export default {
  name: 'BlueProjectsIndex',
  props: ['doc'],
  data () {
    return {
      views: ['past', 'present', 'future'],
      active: this.$route.query.view || 'present',
      today: new Date(),
      loading: true
    }
  },
  computed: {
    ...mapState(['projects']),
    ...mapGetters(['winIs']),
    past () {
      return this.projects
        .filter(prj => this.today > new Date(prj.acf.date_closing))
        .sort((a, b) => {
          const d = (f) => f && f.acf && f.acf.date_opening && new Date(f.acf.date_opening)
          return d(a) < d(b) ? 1 : d(a) > d(b) ? -1 : 0
        })
    },
    pastGridItems () {
      const img = (doc) => {
        const img = get(doc, '_embedded["wp:featuredmedia"][0]')
        return img && { src: img.source_url, alt: img.alt_text }
      }
      return this.past.map(prj => ({ type: prj.type, post: prj, image: img(prj) }))
    }
  },
  methods: {
    rows (view) {
      const sec = this.doc.acf[view + '_body']
      return sec && sec.body
    },
    hasRows (vw) {
      return vw === 'past' ? this.past.length > 0 : this.rows(vw) && this.rows(vw).length > 0
    },
    changeView (view) {
      this.active = view
      this.$router.replace({ query: { view: view } })
    },
    setDefaultView () {
      if (this.hasRows(this.active)) return
      const pref = ['present', 'future', 'past']
      this.active = pref.find(view => this.hasRows(view)) || 'present'
    }
  },
  created () {
    this.$store.dispatch('getBlueProjects').then(() => {
      this.loading = false
      this.setDefaultView()
    })
  },
  components: { BlauTitle, FlexBody, Btn, RespImg }
}
</script>

<style>
</style>
